















































































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../Streamax/fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarTimeHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  hora: any;
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraTimeHowen'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.dateformat.value = parseInt(this.data['?column?'].DateType);
    const [fecha, hora] = this.data.fecha_camara.split(' ');
    this.formFields.fecha.value = moment(new Date(fecha));
    this.formFields.timesync.value = parseInt(this.data['?column?'].switch);
    this.formFields.time.value = moment(hora, 'HHmm');
    this.formFields.timeout.value = this.data['?column?'].OprTimeOut;
    this.formFields.timeZone.value = this.data['?column?'].timezone;
    this.formFields.timeZone2.value = parseInt(
      this.data['?column?'].buzzerSwitch
    );
    this.formFields.ntp.value = this.data['?column?'].ntpserver;
    this.formFields.ntp2.value = this.data['?column?'].ntpport;
    this.formFields.dts.value = parseInt(this.data['?column?'].onoff);
    this.formFields.starttime.value = parseInt(this.data['?column?'].sDate);
    this.formFields.startday.value = this.data['?column?'].sHour;
    this.formFields.startTimeMonth.value = parseInt(
      this.data['?column?'].sMonth
    );
    this.formFields.startdayofweek.value = parseInt(
      this.data['?column?'].sWeek
    );
    this.formFields.endtime.value = parseInt(this.data['?column?'].eDate);
    this.formFields.endday.value = this.data['?column?'].eHour;
    this.formFields.endtimemonth.value = parseInt(this.data['?column?'].eMonth);
    this.formFields.enddayofweek.value = parseInt(this.data['?column?'].eWeek);
    this.formFields.offsettime.value = parseInt(this.data['?column?'].offset);
    console.log(this.data['?column?']);
  }
  mounted() {
    this.getTime();
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    dateformat: any;
    fecha: any;
    timesync: any;
    time: any;
    timeout: any;
    timeZone: any;
    timeZone2: any;
    ntp: any;
    ntp2: any;
    dts: any;
    starttime: any;
    startday: any;
    startTimeMonth: any;
    startdayofweek: any;
    endtime: any;
    endday: any;
    endtimemonth: any;
    enddayofweek: any;
    offsettime: any;
  } = {
    dateformat: {
      label: 'Formato de fecha',
      value: 0,
      items: [
        { label: 'YY/MM/DD', id: 0 },
        { label: 'DD/MM/YY', id: 1 },
        { label: 'MM/DD/YY', id: 2 },
      ],
    },
    fecha: {
      label: 'Fecha',
      value: '',
    },
    timesync: {
      label: 'Time Sync',
      value: 0,
      items: [
        { label: 'Manual', id: 0 },
        { label: 'GPS Adjust', id: 1 },
        { label: 'NTP', id: 2 },
      ],
    },
    time: {
      label: 'Hora',
      value: moment('00:00', 'HHmm'),
      selectedValue: '00:00:00',
    },
    timeout: {
      label: 'TimeOut (Minutos)',
      value: '',
    },
    timeZone: {
      label: 'Time Zone',
      value: 0,
      items: [
        { label: 'GMT+1', id: '230.000000' },
        { label: 'GMT+2', id: '220.000000' },
        { label: 'GMT+3', id: '210.000000' },
        { label: 'GMT+4', id: '200.000000' },
        { label: 'GMT+5', id: '190.000000' },
        { label: 'GMT+6', id: '180.000000' },
        { label: 'GMT+7', id: '170.000000' },
        { label: 'GMT+8', id: '160.000000' },
        { label: 'GMT+9', id: '150.000000' },
        { label: 'GMT+10', id: '140.000000' },
        { label: 'GMT+11', id: '130.000000' },
        { label: 'GMT+12', id: '120.000000' },
        { label: 'GMT-1', id: '110.000000' },
        { label: 'GMT-2', id: '100.000000' },
        { label: 'GMT-3', id: '90.000000' },
        { label: 'GMT-4', id: '80.000000' },
        { label: 'GMT-5', id: '70.000000' },
        { label: 'GMT-6', id: '60.000000' },
        { label: 'GMT-7', id: '50.000000' },
        { label: 'GMT-8', id: '40.000000' },
        { label: 'GMT-9', id: '30.000000' },
        { label: 'GMT-10', id: '20.000000' },
        { label: 'GMT-11', id: '10.000000' },
        { label: 'GMT-12', id: '0.000000' },
      ],
    },
    timeZone2: {
      label: '',
      value: 0,
      items: [
        { label: '00', id: 0 },
        { label: '05', id: 1 },
        { label: '10', id: 2 },
        { label: '15', id: 3 },
        { label: '20', id: 4 },
        { label: '25', id: 5 },
        { label: '30', id: 6 },
        { label: '35', id: 7 },
        { label: '40', id: 8 },
        { label: '45', id: 9 },
        { label: '50', id: 10 },
        { label: '55', id: 11 },
      ],
    },
    ntp: {
      label: 'NTP',
      value: '',
    },
    ntp2: {
      label: 'NTP',
      value: '',
    },
    dts: {
      label: 'DTS',
      value: 0,
      items: [{ label: 'OFF', id: 0 }, { label: 'ON', id: 1 }],
    },
    startTimeMonth: {
      label: 'Start Time',
      value: 0,
      items: [
        { label: 'Jan', id: 0 },
        { label: 'Feb', id: 1 },
        { label: 'Mar', id: 2 },
        { label: 'Apr', id: 3 },
        { label: 'May', id: 4 },
        { label: 'Jun', id: 5 },
        { label: 'Jul', id: 6 },
        { label: 'Aug', id: 7 },
        { label: 'Sep', id: 8 },
        { label: 'Oct', id: 9 },
        { label: 'Nov', id: 10 },
        { label: 'Dec', id: 11 },
      ],
    },
    startday: {
      label: '',
      value: '',
    },
    starttime: {
      label: '',
      value: 0,
      items: [{ label: 'First', id: 0 }, { label: 'Last', id: 1 }],
    },
    startdayofweek: {
      label: '',
      value: 0,
      items: [
        { label: 'Sun', id: 0 },
        { label: 'Mon', id: 1 },
        { label: 'Tue', id: 2 },
        { label: 'Wed', id: 3 },
        { label: 'Thu', id: 4 },
        { label: 'Fry', id: 5 },
        { label: 'Sat', id: 6 },
      ],
    },
    endtimemonth: {
      label: 'End Time',
      value: 0,
      items: [
        { label: 'Jan', id: 0 },
        { label: 'Feb', id: 1 },
        { label: 'Mar', id: 2 },
        { label: 'Apr', id: 3 },
        { label: 'May', id: 4 },
        { label: 'Jun', id: 5 },
        { label: 'Jul', id: 6 },
        { label: 'Aug', id: 7 },
        { label: 'Sep', id: 8 },
        { label: 'Oct', id: 9 },
        { label: 'Nov', id: 10 },
        { label: 'Dec', id: 11 },
      ],
    },
    endday: {
      label: '',
      value: 0,
    },
    endtime: {
      label: '',
      value: 0,
      items: [{ label: 'First', id: 0 }, { label: 'Last', id: 1 }],
    },
    enddayofweek: {
      label: '',
      value: 0,
      items: [
        { label: 'Sun', id: 0 },
        { label: 'Mon', id: 1 },
        { label: 'Tue', id: 2 },
        { label: 'Wed', id: 3 },
        { label: 'Thu', id: 4 },
        { label: 'Fry', id: 5 },
        { label: 'Sat', id: 6 },
      ],
    },
    offsettime: {
      label: 'Offset Time',
      value: 0,
      items: [
        { label: '15 Min', id: 0 },
        { label: '30 Min', id: 1 },
        { label: '45 Min', id: 2 },
        { label: '60 Min', id: 3 },
      ],
    },
  };
  selectedDateFormat() {
    return this.formFields.dateformat.items.find(
      (item: { id: any }) => item.id === this.formFields.dateformat.value
    );
  }
  selectedDts() {
    return this.formFields.dts.items.find(
      (item: { id: any }) => item.id === this.formFields.dts.value
    );
  }
  selectedOffTime() {
    return this.formFields.offsettime.items.find(
      (item: { id: any }) => item.id === this.formFields.offsettime.value
    );
  }
  selectedEndDayWeek() {
    return this.formFields.enddayofweek.items.find(
      (item: { id: any }) => item.id === this.formFields.enddayofweek.value
    );
  }
  selectedEndTime() {
    return this.formFields.endtime.items.find(
      (item: { id: any }) => item.id === this.formFields.endtime.value
    );
  }
  selectedEndMonth() {
    return this.formFields.endtimemonth.items.find(
      (item: { id: any }) => item.id === this.formFields.endtimemonth.value
    );
  }
  selectedStartMonth() {
    return this.formFields.startTimeMonth.items.find(
      (item: { id: any }) => item.id === this.formFields.startTimeMonth.value
    );
  }
  selectedStartTime() {
    return this.formFields.starttime.items.find(
      (item: { id: any }) => item.id === this.formFields.starttime.value
    );
  }
  selectedStartDay() {
    return this.formFields.startdayofweek.items.find(
      (item: { id: any }) => item.id === this.formFields.startdayofweek.value
    );
  }
  selectedDate() {
    return (this.formFields.fecha.value = moment(
      this.formFields.fecha.value
    ).format('DD/MM/YYYY'));
  }
  selectedSwitch() {
    return this.formFields.timesync.items.find(
      (item: { id: any }) => item.id === this.formFields.timesync.value
    );
  }
  selectedTimeZone() {
    return this.formFields.timeZone.items.find(
      (item: { id: any }) => item.id === this.formFields.timeZone.value
    );
  }
  selectedTimeZone2() {
    return this.formFields.timeZone2.items.find(
      (item: { id: any }) => item.id === this.formFields.timeZone2.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  //@Watch('show')
}
